import React from 'react'
import Select from 'react-select'

const WrappedSelect = props => (
  <Select classNamePrefix="react-select" {...props} />
)

export default WrappedSelect
